module.exports = __webpack_public_path__ + "static/media/battery-bolt.ee86fcd9.svg";